import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL } from '@utils/api/endpoints.ts';
import { AiSummaryJob } from './use-create-ai-summary.tsx';

const TERMINAL_STATUSES = ['completed', 'failed', 'cancelled'];

export const useGetAiSummary = (jobId: string | null) => {
  return useQuery<AiSummaryJob>(
    ['aiSummaryJob', jobId],
    async () => {
      const response = await Axios.get(GET_URL(jobId!).aiSummaryJob);
      return response.data;
    },
    {
      enabled: !!jobId,
      refetchInterval: data => {
        if (!data) return 3000;
        return TERMINAL_STATUSES.includes(data.status) ? false : 3000;
      },
      refetchIntervalInBackground: true
    }
  );
};
